import { theme } from '@app/styles/theme'
import { css } from '@emotion/react'

export const gridVars = css`
  --cell-min-width: 80px;
  --header-bg: ${theme.palette.neutral[900]};
  --header-bg-red: ${theme.palette.red.main};
  --selected-bg: #e3f2fd;
  --highlighted-bg: #fafafa;
`

export const tableContainerStyles = css`
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  overflow-x: auto;
`

export const tableStyles = css`
  min-width: 300px;
`

export const axisLabelCellStyles = css`
  &:first-of-type {
    background-color: var(--header-bg);
  }
  background-color: ${theme.palette.neutral.main};
  font-size: 0.65rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${theme.palette.black.main};
  padding: 4px 8px;
  text-align: center;
`

export const yearSpacerCellStyles = css`
  width: 80px;
  background-color: var(--header-bg);
  color: ${theme.palette.black.main};
`

export const colHeaderCellStyles = css`
  font-weight: ${theme.typography.fontWeightRegular};
  background-color: ${theme.palette.neutral.main};
  font-size: 0.75rem;
  min-width: var(--cell-min-width);
  white-space: nowrap;
`

export const rowHeaderCellStyles = css`
  background-color: var(--header-bg);
  font-size: 0.75rem;
  white-space: nowrap;
`

export const scenarioCellBaseStyles = css`
  padding: 6px;
  vertical-align: middle;
  background-color: ${theme.palette.white.main};
`

export const scenarioCellHighlightedStyles = css`
  background-color: var(--highlighted-bg);
`

export const scenarioCellSelectedStyles = css`
  background-color: var(--selected-bg);
`

export const scenarioCellContentStyles = css`
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(2, auto);
  justify-content: center;
  align-items: center;
`

export const emptyCellLabelStyles = css`
  color: ${theme.palette.text.disabled};
`

export const scenarioPillStyles = (
  isSelected: boolean,
  colors: { bg: string; color: string; hoverBg?: string },
) => css`
  background-color: ${isSelected ? (colors.hoverBg ?? colors.bg) : colors.bg} !important;
  color: ${isSelected ? '#fff' : colors.color} !important;
  font-size: 0.7rem;
  border: ${isSelected ? 'none' : `1px solid ${colors.color}22`};
  transition: background-color 0.15s;
  &:hover {
    background-color: ${colors.hoverBg ?? colors.bg} !important;
    color: #fff !important;
  }
`
